import styled from 'styled-components'

export const StyledUnitsInfo = styled.div`
margin-top: ${({ theme }) => theme.rem(76)};

> * + * {
  margin-block-start: ${({ theme }) => theme.rem(100)}
}
`
